import React, { useEffect, useState } from "react";
import { MessageCircle, Search } from "lucide-react";
import BUSINESS from "../../lib/businessInfo.json";

const WHATSAPP_TEXT =
  "Hi! I am looking for an online yoga teacher. Can you help me find the right one?";

const WHATSAPP_URL = `https://wa.me/${BUSINESS.phone.replace(/\D/g, "")}?text=${encodeURIComponent(
  WHATSAPP_TEXT
)}`;

/**
 * Mobile-only action bar. Stays out of the way until the visitor has scrolled
 * past the hero, so it never competes with the hero's own two CTAs.
 */
export default function StickyMobileCta({ onFindTeacher }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => setVisible(window.scrollY > window.innerHeight * 0.7);
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 px-3 pb-[max(0.6rem,env(safe-area-inset-bottom))] pt-2.5 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur transition-transform duration-300 sm:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <div className="flex items-center gap-2.5">
        <button
          type="button"
          onClick={onFindTeacher}
          tabIndex={visible ? 0 : -1}
          className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 py-3 text-sm font-bold text-white shadow-sm shadow-emerald-200 active:bg-emerald-700"
        >
          <Search size={17} strokeWidth={2.5} />
          Find My Yoga Teacher
        </button>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={visible ? 0 : -1}
          aria-label={`Chat with us on WhatsApp at ${BUSINESS.phoneDisplay}`}
          className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-emerald-600 px-4 py-3 text-sm font-bold text-emerald-700 active:bg-emerald-50"
        >
          <MessageCircle size={17} strokeWidth={2.5} />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
